<template>
  <div class="section details">
    <iframe
      class="video"
      src="https://www.youtube.com/embed/raG7NjM0p0k?controls=0"
      title="XD to Flutter plugin is a powerful, easy-to-use tool to export your stunning Adobe XD designs into clean, functional code for Flutter."
      aria-labelledby="the-brief"
      aria-describedby="the-brief-desc"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
    <outcome />
    <download />
  </div>
</template>

<script>
  import Download from "./Download.vue";
  import Outcome from "./Outcome.vue";

  export default {
    name: "Details",
    components: {
      Outcome,
      Download,
    },
  };
</script>

<style scoped lang="scss">
  @import "../variables";

  .details {
    position: relative;
    z-index: 1;

    &::before {
      background: $background;
      content: "";
      width: 100%;
      height: 85%;
      top: 150px;
      right: 0;
      transform: skewY(-7deg);
      position: absolute;
      z-index: -1;
    }

    .video {
      display: flex;
      justify-content: center;
      align-items: center;
      color: $white;
      margin: 0 auto;
      width: 677px;
      max-width: 90%;
      height: 382px;
      border-radius: pxToRem(10);
      margin-bottom: pxToRem(96);
    }
  }
</style>
